export enum ESize {
	unset = 'unset',
	'6xs' = '6xs',
	'5xs' = '5xs',
	'4xs' = '4xs',
	'3xs' = '3xs',
	'2xs' = '2xs',
	xs = 'xs',
	s = 's',
	m = 'm',
	l = 'l',
	xl = 'xl',
	'2xl' = '2xl',
	'3xl' = '3xl',
	'4xl' = '4xl',
	'5xl' = '5xl',
	'6xl' = '6xl',
	'7xl' = '7xl',
	'8xl' = '8xl'
}

export enum EPosition {
	top = 'top',
	topRight = 'topRight',
	topLeft = 'topLeft',
	bottom = 'bottom',
	bottomRight = 'bottomRight',
	bottomLeft = 'bottomLeft',
	left = 'left',
	closeLeft = 'closeLeft',
	closerLeft = 'closerLeft',
	right = 'right',
	closeRight = 'closeRight',
	closerRight = 'closerRight',
	center = 'center',
	none = 'none'
}

export enum EDirection {
	all = 'all',
	horizontal = 'horizontal',
	vertical = 'vertical',
	top = 'top',
	bottom = 'bottom',
	left = 'left',
	right = 'right',
	none = 'none'
}

export enum EMediaQuery {
	min = '0px',
	xs = '480px',
	sm = '660px',
	md = '900px',
	lg = '1200px',
	sxl = '1400px',
	xl = '1600px',
	xxl = '1800px',
	max = '9999px'
}

export enum EThemeColor {
	gold = 'gold',
	transparentGold = 'transparentGold',
	white = 'white',
	black = 'black',
	charcoal = 'charcoal',
	carbon = 'carbon',
	dark = 'dark',
	lead = 'lead',
	grey = 'grey',
	transparentBlack = 'transparentBlack',
	transparent = 'transparent'
}

export enum ETextColor {
	gold = 'gold',
	transparentGold = 'transparentGold',
	gradientGold = 'gradientGold',
	white = 'white',
	grey = 'grey',
	black = 'black',
	success = 'success',
	error = 'error',
	solidity = 'solidity',
	cairo = 'cairo',
	general = 'theory', // need to have the same value as the ETree.general value
	gradientGeneral = 'gradientGeneral'
}

// used to follow request state when fetching data
export enum ERequestState {
	unset = 'unset',
	loading = 'loading',
	success = 'success',
	error = 'error'
}

export enum EAvatarItemType {
	body = 'body',
	head = 'head',
	hair = 'hair',
	eyes = 'eyes',
	eyebrows = 'eyebrows',
	beard = 'beard',
	onHead = 'onHead',
	onChest = 'onChest',
	onHands = 'onHands',
	inLHand = 'inLHand',
	inRHand = 'inRHand',
	onLegs = 'onLegs',
	unset = 'unset'
}

export enum ESubmenuType {
	homeOverview = 'homeOverview',
	stakingOverview = 'stakingOverview',
	stakingProtocols = 'stakingProtocols',
	devhubOverview = 'devhubOverview',
	devhubSkillTree = 'devhubSkillTree',
	devhubQuests = 'devhubQuests',
	devhubCampaigns = 'devhubCampaigns',
	devhubJobBoard = 'devhubJobBoard',
	characterOverview = 'characterOverview',
	characterChests = 'characterChests',
	characterForge = 'characterForge',
	characterInventory = 'characterInventory',
	journalStatistics = 'journalStatistics',
	journalQuestLog = 'journalQuestLog',
	settingsOverview = 'settingsOverview',
	supportFaq = 'supportFaq',
	supportABoutUs = 'supportABoutUs',
	unset = 'unset'
}

export enum ETree {
	noir = 'noir',
	cairo = 'cairo',
	solidity = 'solidity',
	general = 'theory',
	unset = 'unset'
}

export enum ERewardType {
	experience = 'experience',
	gold = 'gold',
	dust = 'dust',
	items = 'items',
	unset = 'unset'
}

export enum EItemRarity {
	common = 'common',
	uncommon = 'uncommon',
	rare = 'rare',
	epic = 'epic',
	legendary = 'legendary',
	unique = 'unique',
	none = 'none'
}

export enum EPageId {
	HomePageAboutUs = 1,
	privacyPolicy = 2,
	termsOfServices = 3
}

export enum ESkillType {
	tools = 'tools',
	lowLevelProgramming = 'lowLevel',
	dataStructure = 'dataStructure',
	designPatterns = 'basicPattern',
	advancedDesignPatterns = 'advancedPattern',
	security = 'basicSecurity',
	advancedSecurity = 'advancedSecurity',
	history = 'history',
	techProtocol = 'protocols',
	techPrimitives = 'primitive',
	ecosystem = 'ecosystem',
	economics = 'economy'
}

export enum EBrowser {
	chrome = 'chrome',
	firefox = 'firefox',
	safari = 'safari',
	brave = 'brave',
	opera = 'opera',
	edge = 'edge',
	ie = 'ie',
	server = 'server',
	other = 'other'
}

export enum ENetworkState {
	mainnet = 'mainnet',
	testnet = 'testnet',
	devnet = 'devnet'
}

export enum EWebsite {
	discord = 'https://discord.gg/5MNvaMjeHW',
	discordSupport = 'https://discord.com/channels/1027220149280981053'
	//discordSupport = 'https://discord.com/channels/1027220149280981053/1027220749833998396'
}

export enum EAvatarType {
	male = 'male', // male is value in the backend
	female = 'female', // female is value in the backend
	unset = 'male' // male is value in the backend
}

export enum EHTMLDisplay {
	none = 'none',
	block = 'block',
	inline = 'inline',
	inlineBlock = 'inline-block',
	inlineFlex = 'inline-flex',
	flex = 'flex',
	grid = 'grid',
	inherit = 'inherit',
	initial = 'initial',
	unset = 'unset'
}

export enum EPage {
	blog,
	HomePageAboutUs,
	unset
}

export enum ENetwork {
	goerli = 'goerli',
	starknetGoerliAlpha = 'starknet-goerli-alpha'
}

export enum EOverflow {
	unset = 'unset',
	visible = 'visible',
	hidden = 'hidden',
	auto = 'auto',
	hiddenAuto = 'hidden auto',
	hiddenVisible = 'hidden visible',
	autoHidden = 'auto hidden',
	visibleHidden = 'visible hidden',
	visibleAuto = 'visible auto',
	autoVisible = 'auto visible'
}

export enum EAssetSize {
	small = 'small',
	medium = 'medium',
	large = 'large',
	xlarge = 'xlarge',
	thumbnail = 'thumbnail'
}
